<template>
  <div class="media-list__item media-list__item-pdf" @click="openDialog">
    
  </div>
</template>

<script>
import Base from './base';

export default {
  extends: Base,
}
</script>
